module.exports = __webpack_public_path__ + "static/media/info.d03e4b98.svg";